<p-tabMenu [model]="bcfStatuts" #tabMenu [activeItem]="activeItem"></p-tabMenu>
<router-outlet></router-outlet>
<yo-dialog-histo-mails></yo-dialog-histo-mails>
<yo-dialog-gef-audit></yo-dialog-gef-audit>



